import {RSAA} from 'redux-api-middleware';
import * as types from './types/index';
import {DEVICE_INFO} from "./types";
import {FREEGEOIP} from "../util/constants";

export function geoip() {
    return {
        [RSAA]: {
            endpoint: FREEGEOIP,
            method: 'GET',
            types: [types.GEOIP_REQUEST, types.GEOIP_RECEIVE, types.GEOIP_FAILURE]
        }
    }
};

export const resetGEOIP = () => ({
    type: types.GEOIP_RESET,
    payload: null
});

export const setDeviceInfo = device => ({
    type: DEVICE_INFO,
    payload:device
});